import React from "react";

interface StatTileProps {
    label: string;
    value: string;
}

export const StatTile: React.FC<StatTileProps> = props => {
    const { label, value } = props;

    return (
        <div className="rounded-lg px-4 py-3 ring-1 ring-gray-200">
            <dt className="text-sm font-medium text-gray-500">{label}</dt>
            <dd className="mt-1 whitespace-nowrap text-2xl font-semibold text-gray-900">
                {value}
            </dd>
        </div>
    );
};
